import { menuFirsts } from "../../constants/menu"
import DepositRefund from "../../pages/depositRefund/depositRefund"
import DepositRefundRequest from "../../pages/depositRefund/depositRefundRequest"

/**
 * เมนูคืนค่ามัดจำแผง 2 ฝั่ง — คนละ menu key คนละหน้า ไม่ใช่หน้าเดียวที่สลับตาม roleId
 * เจ้าหน้าที่เห็นคำร้องทุกราย + พิจารณาได้ / ผู้เช่าเห็นคำร้องของตัวเอง + ส่งคำร้องได้
 */
const routeDepositRefund = [
  {
    ...menuFirsts.DEPOSIT_REFUND,
    /** key ต้องตรงกับ menuFirstKey ที่ backend ส่งมา ไม่งั้น PrivateRoute หา activeMenu ไม่เจอ ปุ่มจะ disable หมด */
    key: menuFirsts.DEPOSIT_REFUND.key,
    name: menuFirsts.DEPOSIT_REFUND.name,
    textName: menuFirsts.DEPOSIT_REFUND.textName,
    active: false,
    appBar: true,
    component: DepositRefund
  },
  {
    ...menuFirsts.DEPOSIT_REFUND_REQUEST,
    key: menuFirsts.DEPOSIT_REFUND_REQUEST.key,
    name: menuFirsts.DEPOSIT_REFUND_REQUEST.name,
    textName: menuFirsts.DEPOSIT_REFUND_REQUEST.textName,
    active: false,
    appBar: true,
    component: DepositRefundRequest
  }
]

export default routeDepositRefund
